var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2123_4144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.07147 11.9555L8.55827 14.1259L4.54708 16.7535C3.97703 17.127 3.10528 17.0285 2.71191 16.4498L0 12.4603L2.21103 10.9958L3.12028 12.283C5.46549 4.44277 12.932 -0.567057 21.0886 0.0518856C29.7118 0.706126 36.4891 7.55226 37 16.0377L36.9967 17.9741C36.5841 25.0156 31.7612 31.0212 25.1339 33.1497C18.0208 35.4342 10.2976 33.0176 5.81802 27.09L7.95572 25.5205C12.0669 30.9958 19.4626 32.9232 25.7998 30.0952C31.9279 27.3609 35.4465 20.7701 34.0822 14.1021C32.7905 7.78539 27.2675 2.96765 20.586 2.58676C13.9679 2.20998 7.73153 6.32012 5.75302 12.7714L7.0698 11.9546L7.07147 11.9555Z",
    fill: "#2024BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7322 20.8922L23.7289 20.8955C23.2105 21.4126 22.3637 21.4159 21.842 20.9021L18.7909 17.8985C18.5801 17.6908 18.4642 17.4306 18.4142 17.1342C18.4042 17.0735 18.4009 17.0111 18.4009 16.9495V9.10602C18.4017 8.38201 18.9976 7.7959 19.7318 7.7959C20.4669 7.7959 21.062 8.38283 21.062 9.10602V15.8931C21.062 16.2419 21.2036 16.576 21.4553 16.8223L23.723 19.0419C24.2431 19.5509 24.2464 20.3783 23.7322 20.8922Z",
    fill: "#2024BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2123_4144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.c4f12a56d1e0f3d1c44d5643fdd754f3.svg";
export { ForwardRef as ReactComponent };